<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="sksq-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            <el-tooltip placement="right">
              <div slot="content">
                待确认：经销商上传的打款凭证待客服确认<br>
                审核中：客服上传的打款凭证待财务审核<br>
                审核通过：财务审核通过的申请<br>
                审核拒绝：财务审核不通过的申请
              </div>
              <span style="cursor: pointer">收款申请 <i class="el-icon-warning-outline" /></span>
            </el-tooltip>
            <!-- <el-button type="primary" class="add-btn" icon="el-icon-plus" @click="editApply()">添加申请</el-button> -->
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search" />
            </div>
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="4">
                <ul class="group-filter">
                  <li :class="type===9?'active':''" @click="change(9)">待确认</li>
                  <li :class="type===0?'active':''" @click="change(0)">审核中</li>
                  <li :class="type===2?'active':''" @click="change(2)">审核通过</li>
                  <li :class="type===1?'active':''" @click="change(1)">审核拒绝</li>
                </ul>
              </el-col>
              <el-col v-loading="loading" :span="20">
                <el-table
                  :key="tableKey"
                  :data="tableData"
                  :show-header="false"
                  style="width: 100%"
                >
                  <el-table-column
                    v-if="type===9"
                    label="经销商"
                    width="160"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.mark===0&&type!==9" :disable-transitions="true" size="mini" type="warning">待审核</el-tag>
                      <el-tag v-if="scope.row.mark===2&&type!==9" :disable-transitions="true" size="mini">审核通过</el-tag>
                      <el-tag v-if="scope.row.mark===1&&type!==9" :disable-transitions="true" size="mini" type="danger">审核拒绝</el-tag>
                      <el-tag v-if="scope.row.mark===0&&type===9" :disable-transitions="true" size="mini" type="warning">待确认</el-tag>
                      <el-tag v-if="scope.row.mark===2&&type===9" :disable-transitions="true" size="mini" type="info">已作废</el-tag>
                      <span style="color:#000;margin-left: 6px;">{{ scope.row.all_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="type!==9"
                    label="收款流水号"
                    width="210"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag v-if="scope.row.mark===0" :disable-transitions="true" size="mini" type="warning">待审核</el-tag>
                      <el-tag v-if="scope.row.mark===2" :disable-transitions="true" size="mini">已通过</el-tag>
                      <el-tag v-if="scope.row.mark===1" :disable-transitions="true" size="mini" type="danger">已拒绝</el-tag>
                      <span style="color:#000;margin-left: 6px;">{{ scope.row.ranum }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="type!==9"
                    label="经销商"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-user" />{{ scope.row.all_name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="单号"
                    width="220"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.paycontent == '账户充值' || scope.row.paycontent == '冲业绩' || scope.row.paycontent == '样品预存款申请'">{{ scope.row.paycontent }}</span>
                      <template v-else>
                        <span v-if="scope.row.ordernum!==null&&scope.row.ordernum!==''&&scope.row.ordernum!==undefined" style="color:#99a9bf">订单号：</span>
                        <span v-if="scope.row.ordernum!==null&&scope.row.ordernum!==''&&scope.row.ordernum!==undefined">
                          {{ scope.row.ordernum }}
                          /
                          <span v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined" style="font-weight: 500;color:#409EFF">{{ scope.row.produnum }}</span>
                          <span v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined" style="font-weight: 500;color:#999999">N/A</span>
                        </span>
                        <span v-if="scope.row.manum!==null&&scope.row.manum!==''&&scope.row.manum!==undefined" style="color:#99a9bf">物料单号：</span>
                        <span v-if="scope.row.manum!==null&&scope.row.manum!==''&&scope.row.manum!==undefined">{{ scope.row.manum }}</span>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="type!==9"
                    label="收款内容"
                    width="160"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">收款内容：</span>
                      <span>{{ scope.row.paycontent }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="收款性质"
                    width="140"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="type!==9 && scope.row.nature" style="color:#99a9bf">性质：</span>
                      <span v-if="type===9" style="color:#99a9bf">提交方式：</span>
                      <span>{{ scope.row.nature }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款日期"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span><i class="el-icon-time" />{{ scope.row.time }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    width="120"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#99a9bf">申请人：</span>{{ scope.row.user_name }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="卡号"
                    min-width="180"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span v-if="scope.row.card && scope.row.paycontent != '退款'"><i class="el-icon-bank-card" />{{ scope.row.card }}</span>
                      <span v-else style="color:#99a9bf">N/A</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="打款金额"
                    width="100"
                    fixed="right"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" />{{ scope.row.amount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :width="type===9?240:120"
                    fixed="right"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.mark===0&&type===9" size="mini" icon="el-icon-document-checked" @click="editApplyConFirm(scope.row.apply_id)">凭证确认</el-button>
                      <el-button v-if="scope.row.mark===2&&type===9" size="mini" icon="el-icon-search" @click="viewConfirm(scope.row)">查看凭证</el-button>
                      <el-button v-if="type===9" size="mini" icon="el-icon-document" @click="goOrder(scope.row.orderid)">查看订单</el-button>
                      <el-dropdown v-if="scope.row.mark!==2&&type!==9" size="mini" split-button icon="el-icon-edit" @click="editApply(scope.row)">
                        <i class="el-icon-edit" /> 编辑
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item style="color:#F56C6C" @click.native="delApply(scope.row)"><i class="el-icon-delete" />删除申请</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button v-if="scope.row.mark===2&&type!==9" size="mini" icon="el-icon-search" @click="view(scope.row)">查看申请</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" v-loading="infoLoading" :model="editForm" :rules="editRules" label-position="right" label-width="90px" size="small">
        <div v-if="!isconfirm && editForm.paycontent!=='样品预存款申请' && editForm.paycontent!=='冲业绩' && editForm.paycontent!=='其他收款'" style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 收款须知：该申请仅限" <b>实际打款</b> "使用，返点/售后赔款/报备金请勿在此申请
        </div>
        <el-form-item v-if="audittime && !isconfirm" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ auditname }}</span>
            </div>
            <div v-if="auditrson!=''&&auditrson!=null" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ auditrson }}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="经销商" prop="delid">
          <el-select v-model="editForm.delid" :disabled="true" filterable clearable style="width:100%;">
            <el-option
              v-for="item in dealerInfo"
              :key="item.delid"
              :label="item.allname"
              :value="item.delid"
            >
              <span style="float: left">{{ item.allname }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.province }} {{ item.city }} {{ item.county }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款账户" prop="aid">
          <el-select v-model="editForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name">
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid"
              >
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="收款内容" prop="paycontent">
          <el-select v-model="editForm.paycontent" :disabled="editForm.paycontent=='账户充值'||editForm.paycontent=='冲业绩'||editForm.paycontent=='其他收款'||editForm.paycontent=='零售项目充值'">
            <el-option
              v-for="item in paycontentList"
              v-if="item.name!=='收款抹零'"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款性质" prop="nature">
          <el-select v-model="editForm.nature" :disabled="editForm.paycontent=='冲业绩'||editForm.paycontent=='其他收款'||editForm.paycontent=='零售项目充值'">
            <el-option
              v-for="item in receiptNatureList"
              :key="item.rntid"
              :label="item.name"
              :value="item.name"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="收款日期" prop="receipttime">
          <el-date-picker
            v-model="editForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="收款金额" prop="money">
          <el-input v-model="editForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card">
          <el-input v-model="editForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit />
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg :key="imgLoad" v-model="editForm.imgids" :limit="9" :size="'sm'" :old="editimgList" />
        </el-form-item>
        <el-form-item v-if="editForm.paycontent=='冲业绩'" label="冲业绩名称" prop="name">
          <el-input v-model="editForm.name" maxlength="100" show-word-limit placeholder="请输入" />
        </el-form-item>
        <el-form-item v-else-if="editForm.paycontent=='其他收款'" label="收款事项" prop="name">
          <el-input v-model="editForm.name" maxlength="100" show-word-limit placeholder="请输入" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button v-if="isconfirm===true" type="primary" icon="el-icon-check" :loading="editloading" @click="subEdit('editForm')">确认添加收款申请</el-button>
          <el-button v-if="isconfirm===true" type="danger" icon="el-icon-close" :loading="editloading" @click="voidData(editForm.racid)">凭证作废</el-button>
          <el-button v-if="isconfirm===false" type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="收款申请"
      :visible.sync="viewVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="viewLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ viewdata.applyname }}</td>
          <th>申请时间</th>
          <td>{{ viewdata.time }}</td>
        </tr>
        <tr v-if="isconfirm===false">
          <th>流水号</th>
          <td>{{ viewdata.ranum }}</td>
          <th v-if="viewdata.orderid!==null&&viewdata.orderid!==''&&viewdata.orderid!==undefined">订单号</th>
          <td v-if="viewdata.orderid!==null&&viewdata.orderid!==''&&viewdata.orderid!==undefined"><span style="color:#409EFF;cursor: pointer" @click="goOrder(viewdata.orderid)"><i class="el-icon-document"></i> {{ viewdata.ordernum }} / {{ viewdata.produnum }}</span></td>
          <th v-if="viewdata.maid!==null&&viewdata.maid!==''&&viewdata.maid!==undefined">物料单号</th>
          <td v-if="viewdata.maid!==null&&viewdata.maid!==''&&viewdata.maid!==undefined">{{ viewdata.manum }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ viewdata.delname }}</td>
          <template v-if="viewdata.paycontent != '退款'">
            <th>卡号</th>
            <td>{{ viewdata.card }}</td>
          </template>
        </tr>
        <tr v-if="viewdata.paycontent != '退款'">
          <th>打款账户</th>
          <td colspan="3">{{ viewdata.account }}</td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ viewdata.receipttime }}</td>
          <th v-if="isconfirm===false">打款性质</th>
          <th v-if="isconfirm===true">提交方式</th>
          <td>{{ viewdata.nature }}</td>
        </tr>
        <tr>
          <th v-if="isconfirm===false">打款内容</th>
          <td v-if="isconfirm===false">{{ viewdata.paycontent }}</td>
          <th>打款金额</th>
          <td :colspan="isconfirm===true?3:1" style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ viewdata.money }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in imgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="imgSrcList"
            />
          </td>
        </tr>
        <tr v-if="viewdata.paycontent == '退款'">
          <th style="width: 100px;">是否减货款</th>
          <td colspan="3">{{ viewdata.card == '1' ? '是' : '否' }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ viewdata.remark }}</td>
        </tr>
        <tr>
          <th v-if="isconfirm===false">审核人</th>
          <th v-if="isconfirm===true">作废人</th>
          <td>{{ viewdata.auditname }}</td>
          <th v-if="isconfirm===false">审核时间</th>
          <th v-if="isconfirm===true">作废时间</th>
          <td>{{ viewdata.audittime }}</td>
        </tr>
        <tr v-if="isconfirm===true">
          <th>作废原因</th>
          <td colspan="3">{{ viewdata.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="viewVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑样品预存款申请"
      :visible.sync="joinVisible"
      width="40%"
      top="6vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="joinForm" :model="joinForm" :rules="joinRules"  label-position="right" label-width="75px" size="small">
        <el-form-item v-if="joinForm.mark == 1 && joinForm.audittime && joinForm.rson" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ joinForm.audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ joinForm.auditname }}</span>
            </div>
            <div v-if="joinForm.rson" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ joinForm.rson }}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="经销商" prop="dealerName">
          <el-input v-model="joinForm.dealerName" :disabled="true" />
        </el-form-item>
        <el-form-item label="店面形式" prop="shopform">
          <el-select v-model="joinForm.shopform" style="width:100%" placeholder="请选择">
            <el-option
              v-for="item in dmxsList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总面积" prop="totalarea">
          <el-input v-model="joinForm.totalarea" maxlength="20" placeholder="请输入店面总面积" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="品牌占用面积" prop="area">
          <el-input v-model="joinForm.area" maxlength="20" placeholder="请输入品牌占用面积" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="门店地址" prop="address">
          <el-input v-model="joinForm.address" maxlength="1000" placeholder="请输入门店地址" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="收款账户" prop="aid">
          <el-select v-model="joinForm.aid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name">
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="收款日期" prop="receipttime">
          <el-date-picker
            v-model="joinForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="收款金额" prop="money">
          <el-input v-model="joinForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card">
          <el-input v-model="joinForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="收款凭证" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" :old="oldJoinImgs" :key="joinImgKey" v-model="joinForm.imgids" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="joinForm.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="joinloading" @click="joinApplyEdit('joinForm')">立即提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="样品预存款申请"
      :visible.sync="jmDetailVisible"
      width="700px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <table v-loading="jmFullscreenLoading" class="tcf-detail-table">
        <tr>
          <th>申请人</th>
          <td>{{ jmDetail.apply_name }}</td>
          <th>申请时间</th>
          <td>{{ jmDetail.time }}</td>
        </tr>
        <tr>
          <th>流水号</th>
          <td>{{ jmDetail.ranum }}</td>
        </tr>
        <tr>
          <th>经销商</th>
          <td>{{ jmDetail.all_name }}</td>
          <th>卡号</th>
          <td>{{ jmDetail.card_num }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3">
            <span v-if="jmDetail.accountname">{{ jmDetail.accountname }}（{{ jmDetail.accountcard }}）</span>
          </td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ jmDetail.pay_time }}</td>
        </tr>
        <tr>
          <th>打款内容</th><td>样品预存款申请</td>
          <th>打款金额</th>
          <td style="color:#409EFF;font-weight: 500;"><i class="el-icon-coin" /> {{ jmDetail.pay_price }}</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image
              v-for="iurl in jmImgSrcList"
              :key="iurl"
              style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
              :src="iurl"
              :preview-src-list="jmImgSrcList"
            />
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ jmDetail.remark }}</td>
        </tr>
        <tr v-if="jmDetail.mark===1 || jmDetail.mark===2">
          <th>审核人</th>
          <td>{{ jmDetail.auditname }}</td>
          <th>审核时间</th>
          <td>{{ jmDetail.audittime }}</td>
        </tr>
        <tr v-if="jmDetail.mark===1">
          <th>驳回原因</th>
          <td colspan="3">{{ jmDetail.rson }}</td>
        </tr>
        <tr v-if="jmDetail.mark===0 && jmDetail.rson">
          <th>上次驳回</th>
          <td colspan="3" style="color:#f56c6c">{{ jmDetail.rson }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="jmDetailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 退款申请 -->
    <el-dialog
      :title="refundApplyForm.id ? '编辑订单退款申请' : '添加订单退款申请'"
      :visible.sync="refundApplyVisible"
      width="600px"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="refundApplyForm" v-loading="refundApplyLoading" :model="refundApplyForm" :rules="refundApplyRules" label-position="right" label-width="90px" size="small">
        <el-form-item v-if="refundApplyForm.id && refundApplyForm.audittime" label="审核信息">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{ refundApplyForm.audittime }}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{ refundApplyForm.auditname }}</span>
            </div>
            <div v-if="refundApplyForm.rson" style="color:#606266;font-size: 13px;">
              <span style="color:#99a9bf">拒绝原因：</span>{{ refundApplyForm.rson }}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="退款日期" prop="receipttime">
          <el-date-picker
            v-model="refundApplyForm.receipttime"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item label="退款金额" prop="money">
          <el-input v-model="refundApplyForm.money" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <div style="font-size: 13px;color:#F56C6C;padding-left:12px;padding-bottom: 20px">
          <i class="el-icon-info" /> 是否减货款：勾选后，退款申请通过时订单总货款金额将会同步减去退款金额；不勾选则仅减少已收款金额，总货款不变。
        </div>
        <el-form-item label="是否减货款" prop="need">
          <el-checkbox v-model="refundApplyForm.need">是否减货款</el-checkbox>
        </el-form-item>
        <el-form-item label="退款凭证" prop="imgids">
          <MultiImg :key="refundApplyImgKey" v-model="refundApplyForm.imgids" :limit="9" :size="'sm'" :old="refundApplyImgList" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="refundApplyForm.remark" type="textarea" maxlength="300" show-word-limit />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="refundApplyLoading" @click="subRefundApply('refundApplyForm')">立即提交</el-button>
          <el-button @click="refundApplyVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getCollectionApplyList, getErpDealerList, getPaycontent, getReceiptNature, getDealerJoinApplyById,
  addOrEditCollectApply, addOrEditDealerJoinApply, addCollectionInfo, addOrEditAchievementApply, addOrEditProjectApply,
  deleteCollect, confirmCollectionInfo, voidCollectionInfo, doRefund
} from '@/api/erp'
import { getAccounts, getGroupReport } from '@/api/pub'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'sksq',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    return {
      viewVisible: false,
      viewLoading: false,
      tableKey: '',
      imgSrcList: [],
      viewdata: [],
      fullscreenLoading: false,
      editTitle: '添加收款申请',
      dealerInfo: [],
      groupList: [],
      receiptNatureList: [],
      accountsList: [],
      paycontentList: [],
      imgLoad: '',
      editimgList: [],
      search: '',
      type: 9,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      audittime: '',
      auditname: '',
      auditrson: '',
      infoLoading: false,
      editForm: {
        racid: '',
        raid: '',
        delid: '',
        aid: null,
        receipttime: '',
        money: null,
        card: '',
        nature: '',
        name: '',
        remark: '',
        paycontent: '',
        imgids: [],
        orderid: ''
      },
      editRules: {
        delid: [{ required: true, message: '请选择经销商', trigger: 'change' }],
        aid: [{ required: true, message: '请选择收款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择收款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        // card: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        paycontent: [{ required: true, message: '请选择收款内容', trigger: 'change' }],
        nature: [{ required: true, message: '请选择收款性质', trigger: 'change' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },
      editloading: false,
      isconfirm: false,

      joinVisible: false,
      joinloading: false,
      joinImgKey: '',
      oldJoinImgs: [],
      joinImgList: [],
      joinForm: {},
      joinRules: {
        aid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        receipttime: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        // card: [{ required: true, message: '请输入汇款人卡号', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }],
        shopform: [{ required: true, message: '请选择店面形式', trigger: 'change' }],
        totalarea: [{ required: true, message: '请输入总面积', trigger: 'blur' }],
        area: [{ required: true, message: '品牌占用面积', trigger: 'blur' }],
        address: [{ required: true, message: '请输入门店地址', trigger: 'blur' }]
      },
      dmxsList: [{ id: 0, name: '商场内店' }, { id: 1, name: '店中店' }, { id: 2, name: '沿街店' }],

      refundApplyVisible: false,
      refundApplyLoading: false,
      refundApplyImgList: [],
      refundApplyImgKey: '',
      refundApplyForm: {},
      refundApplyRules: {
        receipttime: [{ required: true, message: '请选择退款日期', trigger: 'change' }],
        money: [{ required: true, message: '请输入退款金额', trigger: 'blur' }],
        imgids: [{ required: false, message: '请上传退款凭证', trigger: 'change' }],
      },

      // 样品预存款信息
      jmFullscreenLoading: false,
      jmDetailVisible: false,
      jmDetail: {},
      jmImgSrcList: [],
    }
  },
  created() {
    this.getData()
    getErpDealerList({ userid: this.user.dUserid }).then(response => {
      this.dealerInfo = response.data
    }).catch(() => {
      this.dealerInfo = []
    })
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
    getReceiptNature().then(response => {
      this.receiptNatureList = response.data
    }).catch(() => {})
    getPaycontent().then(response => {
      this.paycontentList = response.data
    }).catch(() => {})
  },
  methods: {
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.tableData = []
      this.tableKey = new Date().getTime()
      this.getData()
    },
    Search() {
      if (this.search !== null && this.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        mark: this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        userid: this.user.dUserid,
        groupid: this.user.dGroupid
      }
      getCollectionApplyList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    goOrder(orderid) {
      this.viewVisible = false
      this.$router.push({ path: '/work/order/' + orderid })
    },
    editApply(row) {
      const id = row.apply_id
      const paycontent = row.paycontent
      if (paycontent && paycontent === '退款') {
        this.refundApplyLoading = true;
        addCollectionInfo({
          userid: this.user.dUserid,
          applyid: id
        }).then(response => {
          let data = response.data || {}
          this.refundApplyForm = {
            id: data.ra.crid,
            money: data.ra.money,
            orderId: data.ra.orderid,
            dealerId: data.ra.delid,
            need: data.ra.card == '1' ? true : false,
            receipttime: data.ra.receipttime,
            imgids: [],
            remark: data.ra.remark,
          }
          let oldimgList = []
          for (let img of data.applyInfo.imgs) {
            oldimgList.push({ id: img.img_id, url: img.img_url })
          }
          this.refundApplyImgList = oldimgList
          this.refundApplyImgKey = new Date().getTime()
          this.refundApplyLoading = false
        }).catch(() => {
          this.refundApplyLoading = false
        })
        this.refundApplyVisible = true
        return
      }
      if (paycontent && paycontent === '样品预存款申请') {
        this.joinloading = true;
        addCollectionInfo({
          userid: this.user.dUserid,
          applyid: id,
          joinType: '1'
        }).then(response => {
          this.joinForm = response.data || {}
          let oldimgList = []
          for (let img of response.data.imgList) {
            oldimgList.push({ id: img.img_id, url: img.img_url })
          }
          this.oldJoinImgs = oldimgList
          this.joinImgKey = new Date().getTime()
          this.joinloading = false
        }).catch(() => {
          this.joinloading = false
        })
        this.joinVisible = true
        return
      }
      this.isconfirm = false
      if (id === '0') {
        this.editTitle = '添加收款申请'
        this.editForm.raid = '0'
        this.editForm.racid = ''
        this.editForm.delid = ''
        this.editForm.name = ''
        this.editForm.aid = null
        this.editForm.receipttime = ''
        this.editForm.money = null
        this.editForm.card = ''
        this.editForm.nature = ''
        this.editForm.remark = ''
        this.editForm.paycontent = ''
        this.editForm.imgids = []
        this.editimgList = []
        this.audittime = ''
        this.auditname = ''
        this.auditrson = ''
        this.imgLoad = new Date().getTime()
      } else {
        this.editTitle = '编辑收款申请'
        this.infoLoading = true
        addCollectionInfo({ userid: this.user.dUserid, applyid: id }).then(response => {
          this.editForm.raid = response.data.ra.raid
          this.editForm.delid = response.data.ra.delid
          var curr = this.dealerInfo.find(it => it.delid === this.editForm.delid)
          if (curr == null) {
            this.dealerInfo.push(
              {
                delid: this.editForm.delid,
                allname: response.data.ra.dealerName
              }
            )
          }
          this.editForm.racid = ''
          this.editForm.aid = response.data.ra.aid
          this.editForm.paycontent = paycontent
          this.editForm.receipttime = response.data.ra.receipttime
          this.editForm.money = response.data.ra.money
          this.editForm.card = response.data.ra.card
          this.editForm.nature = response.data.ra.nature
          this.editForm.remark = response.data.ra.remark
          this.editForm.name = response.data.applyInfo.name
          this.editForm.orderid = response.data.ra.orderid
          this.audittime = response.data.ra.audittime
          this.auditname = response.data.ra.auditname
          this.auditrson = response.data.ra.rson
          let oldimgList = []
          for (let img of response.data.applyInfo.imgs) {
            oldimgList.push({ id: img.img_id, url: img.img_url })
          }
          this.editimgList = oldimgList
          this.imgLoad = new Date().getTime()
          this.infoLoading = false
        }).catch(() => {
          this.infoLoading = false
        })
      }
      this.editVisible = true
    },
    editApplyConFirm(id) {
      this.isconfirm = true
      this.editTitle = '确认经销商收款申请'
      this.infoLoading = true
      confirmCollectionInfo({ userid: this.user.dUserid, applyid: id }).then(response => {
        this.editForm.raid = '0'
        this.editForm.racid = response.data.ra.racid
        this.editForm.delid = response.data.ra.delid
        this.editForm.aid = response.data.ra.aid
        this.editForm.receipttime = response.data.ra.receipttime
        this.editForm.money = response.data.ra.money
        this.editForm.card = response.data.ra.card
        this.editForm.nature = ''
        this.editForm.remark = response.data.ra.remark
        this.editForm.name = response.data.applyInfo.name
        this.editForm.orderid = response.data.ra.orderid
        this.audittime = response.data.ra.audittime
        this.auditname = response.data.ra.auditname
        this.auditrson = response.data.ra.rson
        let oldimgList = []
        for (let img of response.data.applyInfo.imgs) {
          oldimgList.push({ id: img.img_id, url: img.img_url })
        }
        this.editimgList = oldimgList
        this.imgLoad = new Date().getTime()
        this.infoLoading = false
      }).catch(() => {
        this.infoLoading = false
      })
      this.editVisible = true
    },
    viewConfirm(row) {
      this.isconfirm = true
      this.imgSrcList = []
      this.viewVisible = true
      this.viewLoading = true
      confirmCollectionInfo({ userid: this.user.dUserid, applyid: row.apply_id }).then(response => {
        this.viewLoading = false
        this.viewdata = response.data.ra
        this.viewdata.applyname = row.user_name
        this.viewdata.delname = row.all_name
        let account = ''
        for (let a of response.data.accountList) {
          if (a.is_select === 1) {
            account = a.account_name + '（' + a.card + '）'
            break
          }
        }
        this.viewdata.account = account
        let imgs = []
        for (let c of response.data.applyInfo.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
      }).catch(() => {
        this.viewLoading = false
      })
    },
    voidData(racid) {
      this.$prompt('请输入作废原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '作废原因不可为空'
      }).then(({ value }) => {
        this.editloading = true
        const data = {
          userid: this.user.dUserid,
          applyid: racid,
          reason: value
        }
        voidCollectionInfo(data).then(response => {
          this.$message({
            type: 'success',
            message: '凭证作废成功'
          })
          this.getData()
          this.editVisible = false
          this.editloading = false
        })
      }).catch(() => {
        this.editloading = false
      })
    },
    delApply(row) {
      this.$confirm('删除此收款申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        deleteCollect({
          userid: this.user.dUserid,
          applyid: row.apply_id,
          joinType: row.paycontent == '样品预存款申请' ? '1' : ''
        }).then(response => {
          this.fullscreenLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let data = {
              userid: this.user.dUserid,
              applyid: this.editForm.raid,
              dealerid: this.editForm.delid,
              date: this.editForm.receipttime,
              paycontent: this.editForm.paycontent,
              money: this.editForm.money,
              accountid: this.editForm.aid,
              card: this.editForm.card,
              nature: this.editForm.nature,
              imgStr: this.editForm.imgids.join(','),
              remark: this.editForm.remark,
              racid: this.editForm.racid,
              orderid: this.editForm.orderid
            }
            // 冲业绩修改不同接口
            if (this.editForm.paycontent == '冲业绩') {
              data.delid = this.editForm.delid
              data.receipttime = this.editForm.receipttime
              data.aid = this.editForm.aid
              data.amount = this.editForm.money
              data.name = this.editForm.name
              data.img = data.imgStr
              addOrEditAchievementApply(data).then(response => {
                this.$message({
                  message: '收款申请提交成功',
                  type: 'success'
                })
                this.editVisible = false
                this.editloading = false
                this.editimgList = []
                this.getData()
              }).catch(() => {
                this.editloading = false
              })
              return
            }
            // 零售项目充值修改不同接口
            if (this.editForm.paycontent == '零售项目充值') {
              data.receiptTime = this.editForm.receipttime
              data.applyId = this.editForm.raid
              data.aid = this.editForm.aid
              data.amount = this.editForm.money
              data.img = data.imgStr
              data.userId = this.user.dUserid
              addOrEditProjectApply(data).then(response => {
                this.$message({
                  message: '收款申请提交成功',
                  type: 'success'
                })
                this.editVisible = false
                this.editloading = false
                this.editimgList = []
                this.getData()
              }).catch(() => {
                this.editloading = false
              })
              return
            }
            addOrEditCollectApply(data).then(response => {
              this.$message({
                message: '收款申请提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.editimgList = []
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    // 修改样品预存款申请
    joinApplyEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid)return false;
        if (this.joinloading) return false;
        this.joinloading = true
        const data = {
          djaid: this.joinForm.djaid,
          userid: this.user.dUserid,
          groupid: this.user.dGroupid,
          dealerid: this.joinForm.delid,
          date: this.joinForm.receipttime,
          money: this.joinForm.money,
          accountid: this.joinForm.aid,
          card: this.joinForm.card,
          imgStr: this.joinForm.imgids.join(','),
          remark: this.joinForm.remark,
          shopform: this.joinForm.shopform,
          totalarea: this.joinForm.totalarea,
          area: this.joinForm.area,
          address: this.joinForm.address
        }
        addOrEditDealerJoinApply(data).then(response => {
          this.$message({
            message: '样品预存款打款申请提交成功',
            type: 'success'
          })
          this.joinForm = {}
          this.joinVisible = false
          this.joinloading = false
          this.joinImgList = []
          this.getData()
        }).catch(() => {
          this.joinloading = false
        })
      })
    },
    subRefundApply(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.refundApplyLoading) {
            if (this.refundApplyForm.money === null || this.refundApplyForm.money === '' || this.refundApplyForm.money === undefined) {
              this.refundApplyForm.money = 0
            }
            if (parseFloat(this.refundApplyForm.money) <= 0) {
              this.$message.error('退款金额不可为0')
              return false
            }
            this.refundApplyLoading = true
            const data = {
              userId: this.user.dUserid,
              id: this.refundApplyForm.id,
              money: this.refundApplyForm.money,
              orderId: this.refundApplyForm.orderId,
              dealerId: this.refundApplyForm.dealerId,
              need: this.refundApplyForm.need ? 1 : 0,
              receipttime: this.refundApplyForm.receipttime,
              imgids: this.refundApplyForm.imgids.join(','),
              remark: this.refundApplyForm.remark,
            }
            doRefund(data).then(response => {
              this.$message({
                message: '订单退款申请提交成功',
                type: 'success'
              })
              this.refundApplyLoading = false
              this.refundApplyVisible = false
              this.getData()
            }).catch(() => {
              this.refundApplyLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },

    view(row) {
      // 样品预存款详情
      if (row.paycontent && row.paycontent == '样品预存款申请') {
        this.jmImgSrcList = []
        this.applyid = ''
        this.jmFullscreenLoading = true
        this.jmDetailVisible = true
        getDealerJoinApplyById({
          djaid: row.apply_id,
		  userid: this.user.dUserid
        }).then(response => {
          this.jmDetail = response.data || {}
          this.jmDetail.ranum = row.ranum
          this.applyid = this.jmDetail.pay_id
          const imgs = []
          for (const c of this.jmDetail.imgList) {
            imgs.push(c.img_url)
          }
          this.jmImgSrcList = imgs
          this.jmFullscreenLoading = false
        }).catch(() => {
          this.jmFullscreenLoading = false
        })
        return
      }
      this.isconfirm = false
      this.imgSrcList = []
      this.viewVisible = true
      this.viewLoading = true
      addCollectionInfo({
        userid: this.user.dUserid,
        applyid: row.apply_id,
      }).then(response => {
        this.viewLoading = false
        this.viewdata = response.data.ra
        this.viewdata.applyname = row.user_name
        this.viewdata.delname = row.all_name
        let account = ''
        for (let a of response.data.accountList) {
          if (a.is_select === 1) {
            account = a.account_name + '（' + a.card + '）'
            break
          }
        }
        this.viewdata.account = account
        let imgs = []
        for (let c of response.data.applyInfo.imgs) {
          imgs.push(c.img_url)
        }
        this.imgSrcList = imgs
      }).catch(() => {
        this.viewLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sksq-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
